import AppDataService from "./AppDataService";

const COMMON_BASE = "auth";

export default class InventoryService {
  static async getInventoryById(id) {
    return await AppDataService.get(`admin/inventory/${id}`);
  }

  static async getFacilityInventoryList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.facilityId ? `facilityId=${data?.facilityId}` : "",
      data?.name ? `searchValue=${data?.name}` : "",
      data?.type ? `type=${data?.type}` : "",
      data?.status ? `status=${data?.status}` : "",
      data?.dashboard ? `dashboard=${data?.dashboard}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(
      `facility/facility/inventory${queryString}`
    );
  }

  static async postRequestInventory(data) {
    return await AppDataService.post(`facility/inventory`, data);
  }

  static async patchFacilityInventoryData(itemId, data) {
    return await AppDataService.patch(`facility/inventory/${itemId}`, data);
  }

  static async deleteFacilityInventory(id) {
    return await AppDataService.delete(`facility/inventory/${id}`);
  }

  // Creates one or more local-adjustment / audit-trail notes for a facility
  // inventory item. `data` is an array of { type, quantity, comment }.
  static async postInventoryNotes(facilityOrderInventoryId, data) {
    return await AppDataService.post(
      `facility-order-inventory-notes/${facilityOrderInventoryId}`,
      data
    );
  }

  // Fetches notes grouped by facility inventory id for multiple comma-separated
  // facilityOrderInventoryIds (used by the bulk summary table).
  static async getInventoryNotesGroupedByIds(ids) {
    return await AppDataService.get(
      `facility-order-inventory-notes/grouped/by-ids?ids=${ids}`
    );
  }

  // Transfers the total note quantity of one or more inventory items to a
  // pharmacy or facility. `data` = { ids: [...], target, facilityId? }.
  static async postBulkTransfer(data) {
    return await AppDataService.post(
      `facility-order-inventory-notes/bulk/transfer`,
      data
    );
  }
}
